const list = {
  path: 'profitslist',
  component: resolve => require(['@/pages/admin/finance/profitslist'], resolve),
  meta: {
    requireAuth: true
  }
}

export default list
